<template>
      <div class="row">
        <div class="col">
          <table  class="table table-info table-bordered table-sm p2">
              <tr>
                  <th>
                     Tipo
                  </th>
              </tr>
              <tr>
                {{ tipo }}
              </tr>
          </table>
        </div>
      </div>
</template>
<script>
export default {
  name: "comp-debug",
  props: ["tipo"],
  data() {
    return {
    };
  },
}
</script>



// WEBPACK FOOTER //
// src/components/DebugComponent.vue